<template>
  <Headline :subtitle="'Wir sind Techies im Herzen'" :seoStyle2="true" :useBorder2img="true">Das sind wir</Headline>
  <div class="pt-4 md:pt-8 xl:pt-16 pb-32 lg:my-5">
    <WhoWeAre />
    <Technical />
    <References />
    <Team />
    <div class="container max-w-screen-lg 2xl:max-w-screen-xl py-6 sm:py-0 pb-4 px-4 xl:px-8 text-center">
      <ContactInfos />
    </div>
  </div>
</template>

<script>
import Headline from './../views/Headline.vue'
import WhoWeAre from '../views/WhoWeAre.vue'
import Technical from './../views/Technical.vue'
import Team from './../views/Team.vue'
import References from './../views/References.vue'
import ContactInfos from './../views/ContactInfos.vue'

export default {
  name: 'AboutUs',
  components: {
    Headline,
    WhoWeAre,
    Technical,
    Team,
    ContactInfos,
    References
  },
  methods: {
  }
}
</script>

<style scoped>
</style>